namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{

			export interface IInputUIDefinition
			{
				input:		ui.Form.BasicInputField;
				label?:		string;
				size:			ui.TwitterBootstrap3_3.IGridSize;
			}
			export abstract class AbstractEntry extends ui.Box.Box
			{

				protected readonly m_Orga: OrgaTree;

				public constructor( orga: OrgaTree )
				{
					super( true );

					this.m_Orga = orga;
					this.addClass('col-xs-12 col-lg-9 box-style');
					this.css(
						{
							// 'width': '77%',
							'overflow-y': 'auto',
							'padding': '15px'
						}
					);
				}

				protected AddInput( container: ui.base.BaseHTMLElement, _form: ui.Form.Form, _input: IInputUIDefinition[] )
				{
					const formgroup = new ui.base.BaseHTMLElement<HTMLDivElement>( 'div' )
						.addClass( 'form-group clearfix' )
						.appendTo( container );

					_input.forEach( ( def: IInputUIDefinition ) =>
						{
							const inputID = ui.utils.UUID.Gen();
							_form.Input( def.input );

							if ( def.label )
							{
								const label = new ui.base.BaseHTMLElement<HTMLLabelElement>( 'label' );

								label.text( def.label );

								label.attr( 'for', inputID );

								label.addClass( 'col-xs-' + ( 10 - def.size.xs >= 0 ? 12 - def.size.xs : 12 ) );
								label.addClass( 'col-sm-' + ( 10 - def.size.sm >= 0 ? 12 - def.size.sm : 12 ) );
								label.addClass( 'col-md-' + ( 10 - def.size.md >= 0 ? 12 - def.size.md : 12 ) );
								label.addClass( 'col-lg-' + ( 10 - def.size.lg >= 0 ? 12 - def.size.lg : 12 ) );

								formgroup.append( label );
							}

							def.input.Base().addClass( 'col-xs-' + def.size.xs );
							def.input.Base().addClass( 'col-sm-' + def.size.sm );
							def.input.Base().addClass( 'col-md-' + def.size.md );
							def.input.Base().addClass( 'col-lg-' + def.size.lg );

							def.input.rebuild( formgroup );
						}
					);
				}

			}
		}
	}
}
